import React from "react";
import Icon from "assets/icons";
import classNames from "classnames";
import Button from "shared/components/button";
import useOnOutSideClick from "shared/hooks/useOnOutSideClick";

export default function ColumnSelector(props: { tableRef: any; hasSearchIcon: boolean }) {
  const [openSelector, setOpenSelector] = React.useState(false);
  const [, setForceRender] = React.useState(0);
  const autoCloseRef = React.useRef<HTMLDivElement>(null);
  const closeHandler = React.useCallback(() => {
    setOpenSelector(false);
  }, []);
  useOnOutSideClick({ node: autoCloseRef.current, onOutSideClick: closeHandler });

  const allColumns = props.tableRef?.current.allColumns;
  const fixedColumns = props.tableRef?.current.fixedColumns;
  const isSearchable = props.tableRef?.current.isSearchable;
  const setIsSearchable = props.tableRef?.current.setIsSearchable;
  const setAllFilters = props.tableRef?.current.setAllFilters;
  const setFilter = props.tableRef?.current.setFilter;
  const update = React.useCallback(() => {
    setTimeout(() => {
      setForceRender(c => c + 1);
    }, 100);
  }, []);

  return (
    <div className="table_manageColumns" ref={autoCloseRef}>
      {props.hasSearchIcon && (
        <Button
          hasShadow
          icon={<Icon.Search size={18} />}
          className={classNames("", { isSearchable: isSearchable })}
          onClick={() => {
            setIsSearchable((c: any) => {
              if (c) {
                setAllFilters([]);
              }
              return !c;
            });
            update();
          }}
        />
      )}
      <Button
        hasShadow
        icon={<Icon.Manage size={16} />}
        onClick={() => setOpenSelector(!openSelector)}
        className={classNames("", { buttonClose: openSelector })}
      />
      {openSelector && (
        <div className={classNames("table_manageColumns_list", { show: openSelector })}>
          <ul className="list-unstyled">
            {allColumns.map((column: any) => (
              <li key={column.id}>
                <div
                  className={classNames("table_manageColumns_list_checkBox", {
                    isDisabled: fixedColumns.includes(column.id)
                  })}>
                  <label>
                    <input
                      type="checkbox"
                      disabled={fixedColumns.includes(column.id)}
                      {...column.getToggleHiddenProps()}
                      onClick={async () => {
                        if (column.isVisible && column.canFilter) {
                          await setFilter(column.id, "");
                        }
                        await update();
                      }}
                    />
                    <b className="smooth"></b>
                    <span>{column.Header}</span>
                  </label>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
